import axios from "axios";

export default function getSlaConfigs() {
  return new Promise((resolve, reject) =>
    axios
      .get("/support/api/v1/admin/sla-configs")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
